import LoanPage from './LoanPage';

export default LoanPage;
